import { render, staticRenderFns } from "./result-card-query-ranking.component.vue?vue&type=template&id=73402343&scoped=true"
import script from "./result-card-query-ranking.component.vue?vue&type=script&lang=ts"
export * from "./result-card-query-ranking.component.vue?vue&type=script&lang=ts"
import style0 from "./result-card-query-ranking.component.vue?vue&type=style&index=0&id=73402343&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73402343",
  null
  
)

export default component.exports